import * as React from 'react';
import { connect } from 'react-redux';
import { match as Match } from 'react-router';

import { GlobalPrivateState, formatNumber, QueryParameterState } from 'src/api';

import './../UserList/UserList.scss';
import './Pricing.scss';
import { UserModel, washbasinPartDetails, isoDetails, getPartDetail, isoDetailsArray, CurrencyCodes } from 'franke-trough-dependencies';
import { filterUsersBySword } from '../utils';
import { Button, Tooltip } from 'reactstrap';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { PricingDispatcher } from 'src/app/Container/Dispatcher/PricingDispatcher';
import PricingSwitchView from './PricingSwitchView';
import Pricings from './Pricings';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';
import PeriodSelectionDropdown from '../../Configuration/Checkout/Parts/PeriodSelectionDropdown';
 
export interface PricingsWashbasinProps {
  match: Match<{pricingId: string}>;
  pricing: GlobalPrivateState['pricing'];
  pricings: GlobalPrivateState['pricings'];
  params: QueryParameterState['params'];
  dispatch: any;
  history: any;
}

const PricingsWashbasinList = ({ items, currency, selectedGroupKey, handleChangeValue, disabled, hideHeader }: any) => {
  
  return (
    <ol className="pricings-list">
      {!hideHeader && (
        <li className="pricings-list__header">
          <span className="pricings-list__cell pricings-list__body">Washbasin Component</span>
          <span className="pricings-list__cell pricings-list__price">Price in {currency} (per piece / m)</span>
        </li>
      )}
      {items && items.map((item: any, index: number) => {
        if (selectedGroupKey !== item.groupKey) { return null }

        const name = getPartDetail(item.key, 'name', 'de', false, 'washbasin').replace('TARGETCURRENCY', currency);
        const description = getPartDetail(item.key, 'description', 'de', false, 'washbasin');
        const type = getPartDetail(item.key, 'type', 'de', false, 'washbasin');
        
        return (
          <li className="pricings-list__item" key={item.key+item.groupKey} title={item.key}>
            <span className="pricings-list__cell pricings-list__body">
              {name}
              <i>{description}</i>
            </span>
            <span className="pricings-list__cell pricings-list__price">
              <input 
                type="text" 
                value={item.value || ''} 
                onChange={(e) => handleChangeValue(e, item.key, item.groupKey)} 
                disabled={disabled} />
              <div>{type === 'percentage' ? '%' : currency}</div>
            </span>
          </li> 
        );
      })}
    </ol>
  )
}

export class PricingsWashbasinPartial extends React.Component<PricingsWashbasinProps, any> {
  constructor(props: PricingsWashbasinProps) {
    super(props);

    const availableMarkets = isoDetailsArray.filter(([key, isoDetail]) => isoDetail.isValidMarket);
    const partKeys = Object.keys(washbasinPartDetails);
    const initialItems: any = [];
  
    for (const partKey of partKeys) {
      // General parts (eg. sales factor) can be set for each market
      if (partKey.includes('general_')) {
        for (const isoDetail of availableMarkets) {
          const item = {
            key: partKey,
            value: formatNumber(0, { minimumFractionDigits: 2, maximumFractionDigits: 2}),
            groupKey: isoDetail[1].isoCode
          }
          initialItems.push(item);
        }
      } else {
        const item = {
          key: partKey,
          value: formatNumber(0, { minimumFractionDigits: 2, maximumFractionDigits: 2}),
          groupKey: 'de'
        }
        initialItems.push(item);
      }
    }

    this.state = {
      hasChanged: false,
      pricing: {
        id: this.pricingId,
        dateFrom: null,
        dateUntil: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
        items: initialItems
      }
    }
  }

  componentDidUpdate(prevState: PricingsWashbasinProps) {
    const prevPricing = prevState.pricing.result;
    const pricing = this.props.pricing.result;

    // console.log('pricing', prevPricing, prevState.pricing, this.props.pricing);

    // Finished updating/saving
    const pricingUpdated = this.state.pricing.dateFrom && prevState.pricing.updating && !this.props.pricing.updating;
    const pricingSwitched = (pricing && pricing.id) && (prevPricing && prevPricing.id) && prevPricing.id !== pricing.id;
    if (pricingUpdated && !pricingSwitched) {
      this.setState({
        showSaved: true
      });

      setTimeout(() => {
        this.setState({
          showSaved: false
        });
      }, 4000);
    }
    
    const pricingsChanged = pricing && prevPricing !== pricing;
    if (pricingsChanged && pricing) {
      // We generate the pricing items from the part keys and markets... if we update these, we make sure that it reflects even with existing periods
      const mergedPricingItems = this.state.pricing.items;

      for (const item of mergedPricingItems) {
        const matchingItem = pricing.items && pricing.items.find((i: any) => i.key === item.key && i.groupKey === item.groupKey);
        
        if (matchingItem) {
          item.value = matchingItem.value;
        } else {
          item.value = '0.00';
        }
      }

      pricing.items = mergedPricingItems;

      this.setState({
        pricing: pricing
      });
    }

    // History usage...
    if (this.pricingId && this.pricingId !== this.state.pricing.id) {
      this.dispatchPricing(this.pricingId);
    }
  }

  public render() {
    const { pricing } = this.state;
    const { params } = this.props;
    const selectedGroupKey = params.groupKey || 'de';

    const washbasinListDefaultParams = {
      currency: '€',
      selectedGroupKey: 'de',
      handleChangeValue: this.handleChangeValue,
      disabled: this.props.pricing.updating
    }

    return (
      <div className="partial-pricings-washbasin">
        {(!this.props.pricings || !this.props.pricings.result) && (
          <PricingsDispatcher />
        )}
        <PricingDispatcher id={this.state.pricing.id} />
        <div className="partial-pricings-washbasin__heading mb-4">
          <h2>
            Prices Washbasin
          </h2>
          <div className="partial-pricings-washbasin__selector">
            <PeriodSelectionDropdown 
              pricings={this.props.pricings} 
              selectedPeriod={this.state.pricing.id} 
              type="washbasin" 
              isDisabled={this.props.pricing.updating}
              onChange={(event: any, type: string) => {
                const newId = event.target.value;
                this.props.history.replace(`/pricings-washbasin/${newId}`);
                this.dispatchPricing(newId);
              }}
              label="Time Period" />
          </div>
        </div>

        <h3 className="mb-3">Plate</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('plate_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Apron</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('apron_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Surge edge (3 mm)</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('surgeedge_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Backsplash (> 3 - 100 mm)</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('backsplash_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Radius / Bevel / Bevel cut</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('radius_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Cut-out</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('cutout_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Troughs (per trough)</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('trough_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Colour (surchage)</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('color_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Mounting</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('mounting_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Packaging</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('packaging_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Pallet</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('pallet_'))} 
          {...washbasinListDefaultParams}  />

        <h3 className="mb-3">Completion</h3>
        <PricingsWashbasinList 
          items={pricing && pricing.items && pricing.items.filter((item: any) => item.key.startsWith('completion'))} 
          {...washbasinListDefaultParams}  />

        <div className="pricings-list__cta">
          <Button className="btn" onClick={() => this.handleSave()} 
            disabled={this.props.pricing.updating || !this.state.hasChanged} 
            id="pricings-list__cta-btn">
            <span className="btn-name">
              Save all changes
            </span>
          </Button>
          {this.state.showSaved && (
            <Tooltip
              autohide={false}
              isOpen={true}
              placement="top"
              target="pricings-list__cta-btn"
            >
              {this.props.pricing.error && (
                this.props.pricing.error.message
              ) || (
                <>Changes have been saved successfully</>
              )}
            </Tooltip>
          )}
        </div>
      </div>
    );
  }

  dispatchPricing = (pricingId: string) => {
    this.props.dispatch(requestAPIActions.load(
      'pricing', {
        url: `/Pricings/${pricingId}`
      },
      true
    ));

    this.setState({
      pricing: {
        ...this.state.pricing,
        id: pricingId
      }
    });
  }

  handleSave = () => {
    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>('pricing', {
      url: '/Pricings',
      options: {
        method: 'PATCH',
        data: this.state.pricing,
      }
    }));

    this.setState({
      ...this.state, 
      hasChanged: false
    });
  }

  handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>, key: string, groupKey: string) => {
    let newValue = event.target.value;
    newValue = newValue.replace(',', '.');
    newValue = newValue.replace(/[^0-9.]/g, '');

    const editedItems = this.state.pricing.items;
    const editedItem = editedItems.find((item: any) => item.key === key && item.groupKey === groupKey);
    editedItem.value = newValue;

    this.setState({
      ...this.state, 
      items: editedItems,
      hasChanged: true
    });
  }

  private get pricingId(): string | undefined {
    const { match } = this.props;

    return match && match.params && match.params.pricingId;
  }
}

export const PricingsWashbasin = connect((state: GlobalPrivateState) => ({
  pricing: state.pricing,
  pricings: state.pricings,
  params: state.queryState.params,
}))(PricingsWashbasinPartial);

export default PricingsWashbasin;
